var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      on: { shown: _vm.loadProfAndCentersAuthorized },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("paginated-table", {
        attrs: {
          fields: _vm.profAndCenterAuthorized.fields,
          items: _vm.profAndCenterAuthorized.data,
          "empty-text": _vm.$t("noDataProfAndCenterAuthorized")
        },
        scopedSlots: _vm._u(
          [
            !_vm.$route.query.h
              ? {
                  key: "cell(remove)",
                  fn: function(data) {
                    return [
                      data.item.canDecline
                        ? _c("span", {
                            staticClass: "revoke-access",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("revokeAccess"))
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.revokeAccess(data)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0ea1a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0ea1a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryProfAndCenterAuthorized.vue
// module id = 1692
// module chunks = 116